// extracted by mini-css-extract-plugin
module.exports = {"root":"Faq_root__1ryT7","wrapper":"Faq_wrapper__1MtM4"};